import { ComponentType } from 'react';
import { t } from '@lingui/macro';

import { SERVICE_TYPE_CHOICES } from '@rover/constants/src/translations/service.constants';
import { Boarding, Daycare, DropIn, Grooming, Sitting, Walking } from '@rover/icons';
import { ServiceTypeSlug } from '@rover/types';

export type ServiceDescriptorType = {
  type: ServiceTypeSlug;
  lowerUnit?: string;
  lowerUnitPlural?: string;
  typeAccusative?: string;
  unit: string;
  unitPlural: string;
  ratesText: string;
  title: string;
  titleSingular?: string;
  subtitle: string;
  icon: string;
  iconComponent: ComponentType;
};

export const OVERNIGHT_BOARDING = (): ServiceDescriptorType => ({
  type: SERVICE_TYPE_CHOICES.boarding,
  typeAccusative: t`boarding`,
  unit: t`Nightly`,
  unitPlural: t`Nightly`,
  ratesText: t`Nightly rates`,
  title: t`Boarding`,
  subtitle: t`in the sitter's home`,
  icon: 'rover-icon-sitter-home',
  iconComponent: Boarding,
});

export const OVERNIGHT_TRAVELING = (): ServiceDescriptorType => ({
  type: SERVICE_TYPE_CHOICES.traveling,
  typeAccusative: t`sitting`,
  unit: t`Nightly`,
  unitPlural: t`Nightly`,
  ratesText: t`Nightly rates`,
  title: t`House Sitting`,
  subtitle: t`in your home`,
  icon: 'rover-icon-sitter-traveling',
  iconComponent: Sitting,
});
export const DAYCARE = (): ServiceDescriptorType => ({
  type: SERVICE_TYPE_CHOICES.dayCare,
  lowerUnit: t`day care`,
  lowerUnitPlural: t`day care`,
  unit: t`Daily`,
  unitPlural: t`Daily`,
  ratesText: t`Daily rates`,
  title: t`Doggy Day Care`,
  subtitle: t`in the sitter's home`,
  icon: 'rover-icon-daycare',
  iconComponent: Daycare,
});
export const DROP_IN = (): ServiceDescriptorType => ({
  type: SERVICE_TYPE_CHOICES.dropIn,
  lowerUnit: t`visit`,
  lowerUnitPlural: t`visits`,
  unit: t`Visit`,
  unitPlural: t`Visits`,
  ratesText: t`Visit rates`,
  title: t`Drop-In Visits`,
  titleSingular: t`Drop-In Visit`,
  subtitle: t`in your home`,
  icon: 'rover-icon-homevists',
  iconComponent: DropIn,
});

export const DOG_TRAINING = (): ServiceDescriptorType => ({
  type: SERVICE_TYPE_CHOICES.training,
  lowerUnit: t`training session`,
  lowerUnitPlural: t`training sessions`,
  unit: t`Session`,
  unitPlural: t`Sessions`,
  ratesText: t`Session rates`,
  title: t`Dog Training`,
  subtitle: t`in your home`,
  icon: 'rover-icon-homevists', // Change this when we get the dog training icon set up (DEV-73865)
  iconComponent: DropIn,
});

export const WALKING = (): ServiceDescriptorType => ({
  type: SERVICE_TYPE_CHOICES.walking,
  lowerUnit: t`walk`,
  lowerUnitPlural: t`walks`,
  unit: t`Walk`,
  unitPlural: t`Walks`,
  ratesText: t`Walk rates`,
  title: t`Dog Walking`,
  subtitle: t`in your neighborhood`,
  icon: 'rover-icon-walking',
  iconComponent: Walking,
});
export const GROOMING = (): ServiceDescriptorType => ({
  type: SERVICE_TYPE_CHOICES.assignmentGrooming,
  lowerUnit: t`groom`,
  lowerUnitPlural: t`grooms`,
  unit: t`Groom`,
  unitPlural: t`Grooms`,
  ratesText: t`Grooming rates`,
  title: t`Grooming`,
  subtitle: t`in your home`,
  icon: 'rover-icon-grooming',
  iconComponent: Grooming,
});

export const SERVICES = (): ServiceDescriptorType[] => [
  OVERNIGHT_BOARDING(),
  OVERNIGHT_TRAVELING(),
  DROP_IN(),
  WALKING(),
  DAYCARE(),
  GROOMING(),
  DOG_TRAINING(),
];
export default SERVICES;
